import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
export var isPrerender = function() {
    var _getGlobalProperty_userAgent, _getGlobalProperty;
    return ((_getGlobalProperty = getGlobalProperty("navigator")) === null || _getGlobalProperty === void 0 ? void 0 : (_getGlobalProperty_userAgent = _getGlobalProperty.userAgent) === null || _getGlobalProperty_userAgent === void 0 ? void 0 : _getGlobalProperty_userAgent.toLowerCase().includes("prerender")) || getGlobalProperty("isPrerender", false);
};
